import React from "react";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";

export default function PageHero({ fileNo, classification = "CLASSIFICATION: PUBLIC RESEARCH", title, lines = [], lede, meta = [] }) {
    const titleLines = lines.length ? lines : [title];
    return (
        <section className="relative border-b border-white/10 overflow-hidden">
            <div className="pointer-events-none absolute inset-0 opacity-[0.55] bg-[radial-gradient(ellipse_at_top_right,rgba(245,158,11,0.09),transparent_55%)]" />
            <div className="relative mx-auto max-w-7xl px-5 sm:px-8 pt-28 sm:pt-36 pb-14 sm:pb-20">
                <div className="flex flex-wrap items-center gap-3 font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.25em] text-ash mb-8">
                    <span className="border border-amber/40 text-amber px-2 py-1">FILE NO. {fileNo}</span>
                    <span className="hidden sm:inline">{classification}</span>
                    {meta.map((m) => (
                        <span key={m} className="hidden md:inline">· {m}</span>
                    ))}
                </div>
                <h1 className="font-display font-medium text-paper leading-[1.02] text-[clamp(2.5rem,7.5vw,6rem)]">
                    {titleLines.map((line, i) => (
                        <span key={i} className="block overflow-hidden pb-[0.09em] -mb-[0.09em]">
                            <span
                                className="block"
                                style={{
                                    animation: `hero-rise 1s cubic-bezier(0.16,1,0.3,1) ${i * 0.12}s both`,
                                }}
                            >
                                {line}
                            </span>
                        </span>
                    ))}
                </h1>
                {lede && (
                    <p className="mt-8 max-w-3xl text-base sm:text-lg leading-relaxed text-ash">{lede}</p>
                )}
            </div>
            <style>{`@keyframes hero-rise { from { transform: translateY(110%); } to { transform: translateY(0); } }`}</style>
        </section>
    );
}
